import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ChatKeys } from "web_myplann/Api/Chat/ChatKeys";
import { invalidateNotifications } from "web_myplann/Api/Notifications/notificatioKeys";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import {
	type ChatSetReadMessageInputDto,
	postChatSetReadMessage,
} from "web_myplann/Infrastructure/ApiOld/Api";
import { logWarning } from "web_myplann/Infrastructure/sentry";
import { device } from "web_myplann/Utils/device";

export const useSetReadMessageMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (variables: ChatSetReadMessageInputDto) =>
			processResponse(postChatSetReadMessage, { skipToastFor: true })(
				variables,
			),
		onSuccess: (response) => {
			queryClient.invalidateQueries({ queryKey: ChatKeys.list() });
			invalidateNotifications(queryClient);

			const unreadCount = Number(response?.data.not_read);
			if (Number.isFinite(unreadCount)) {
				device
					.setChatUnreadCount(unreadCount)
					.catch(() => logWarning("Failed to send chat unread count to app"));
			}
		},
	});
};
